@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

@mixin resize($value) {
  &.resize-#{$value} {
    resize: $value;
  }
}

@mixin status($textareaColor, $textareaBorderColor, $textareaLabelColor, $statusText) {
  .textarea-element {
    color: $textareaColor;
    border-color: $textareaBorderColor;
  }

  .textarea-label {
    color: $textareaLabelColor;
  }

  .status-text {
    color: $statusText;
  }
}

.textarea-wrapper {
  position: relative;

  &.error {
    @include status(
      $textarea-error-color,
      $textarea-error-border-color,
      $textarea-error-label-color,
      $textarea-error-label-color
    );
  }

  &.success {
    @include status(
      $textarea-success-color,
      $textarea-success-border-color,
      $textarea-success-label-color,
      $textarea-success-label-color
    );
  }

  &:not(.with-status):hover {
    .textarea-element:not([disabled]):not([readonly]) {
      color: $textarea-hover-color;
      border-color: $textarea-hover-border-color;
      background-color: $textarea-hover-background-color;
    }
  }

  .required-mark {
    color: $textarea-mark-required-color;
  }

  .textarea-label {
    display: block;
    font-family: $textarea-font-family;
    margin-top: $textarea-label-margin-top;
    margin-right: $textarea-label-margin-right;
    margin-bottom: $textarea-label-margin-bottom;
    margin-left: $textarea-label-margin-left;
  }

  .status-text {
    display: block;
    font-family: $textarea-font-family;
    margin-top: $textarea-status-text-margin-top;
    margin-right: $textarea-status-text-margin-right;
    margin-bottom: $textarea-status-text-margin-bottom;
    margin-left: $textarea-status-text-margin-left;
  }
}

:host {
  display: $textarea-host-display;
}

.textarea-element {
  display: $textarea-display;
  width: $textarea-width;
  min-width: $textarea-min-width;
  max-width: $textarea-max-width;
  height: $textarea-height;
  min-height: $textarea-min-height;
  max-height: $textarea-max-height;
  font-family: $textarea-font-family;
  font-size: $textarea-font-size;
  line-height: $textarea-line-height;
  margin-top: $textarea-margin-top;
  margin-left: $textarea-margin-left;
  margin-bottom: $textarea-margin-bottom;
  margin-right: $textarea-margin-right;
  padding-top: $textarea-padding-top;
  padding-left: $textarea-padding-left;
  padding-bottom: $textarea-padding-bottom;
  padding-right: $textarea-padding-right;
  border-radius: $textarea-border-radius;
  color: $textarea-color;
  border: $textarea-border-width $textarea-border-style $textarea-border-color;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 $textarea-focus-outline-width $textarea-focus-outline-color;
  }

  &[disabled] {
    background-color: $textarea-disabled-background-color;
    color: $textarea-disabled-color;
    border-color: $textarea-disabled-border-color;
  }

  &[readonly] {
    color: $textarea-readonly-color;
    border-color: $textarea-readonly-border-color;
  }

  &::placeholder {
    color: $textarea-placeholder-color;
  }

  @include resize(both);
  @include resize(horizontal);
  @include resize(vertical);
  @include resize(inherit);
  @include resize(none);
}

@media (max-width: $breakpoint-mobile) {
  .textarea-wrapper {
    --air-textarea-width: #{$mobile-textarea-width};
    width: #{$mobile-textarea-width};
  }
}
